import { createFileRoute, redirect } from '@tanstack/react-router'

import BookmarkedContent from '@/bookmarked/components/BookmarkedContent/BookmarkedContent'
import { FEATURE_DASHBOARD_BOOKMARKED } from '@/core/constants/features'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'

export const Route = createFileRoute('/_learning/_my-learning/home/bookmarked')(
  {
    head: () => ({
      meta: [
        {
          title: buildPageTitle({
            titleKey: 'page-title-my-list',
          }),
        },
      ],
    }),
    beforeLoad: ({ context: { user } }) => {
      if (!user?.features.includes(FEATURE_DASHBOARD_BOOKMARKED)) {
        throw redirect({ to: '/home' })
      }
    },
    component: RouteComponent,
  },
)

function RouteComponent() {
  return <BookmarkedContent />
}
